module.exports = __webpack_public_path__ + "static/media/info-products.31187538.jpeg";